import { Box, CircularProgress, LinearProgress } from "@mui/material";
import "./styles.css";
import { FC } from "react";
const Loader: FC = () => {
  return (
    <Box className="loaderContainer">
      <CircularProgress
        size={60}
        sx={{
          backgroundColor: "", // Track color (behind bar)
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#43463B", //  Your custom bar color
          },
        }} 
        />
    </Box>
  );
};

export default Loader;
